<template>
  <div>
    <v-layout row wrap mt-2 px-2>
      <v-date
       :hideDetails="true"
        :clearable="false"
        v-model="start_date"
        format="YYYY-MM-DD"
        value-type="YYYY-MM-DD"
        @input="reloadActivities"
        :placeholder="$t('from_date')"
        class="flex xs12 sm6 md3 px-1 hide-details"
      />
      <v-date
       :hideDetails="true"
        :clearable="false"
        v-model="end_date"
        format="YYYY-MM-DD"
        :min-date="start_date"
        value-type="YYYY-MM-DD"
        @input="reloadActivities"
        :placeholder="$t('to_date')"
        input_id="start_date_expo_endd"
        class="flex xs12 sm6 md3 px-1 hide-details"
      />
      <v-spacer />
      <v-text-field
        hide-details
        v-model="search"
        append-icon="search"
        :placeholder="$t('search')"
        class="flex xs12 md4 pl-2 mb-3"
      />
    </v-layout>
    <v-data-table
      ref="tbl"
      :items="items"
      :search="search"
      :loading="loading"
      :headers="headers"
      class="elevation-1"
      :rows-per-page-items="per_page"
    >
      <template slot="items" slot-scope="{ item }">
        <td>{{ item.id }}</td>
        <td>{{ item.description }}</td>
        <td>{{ item.log_name }}</td>
        <td>{{ item.subject_id }}</td>
        <td>
          <tree-view
            :options="{ maxDepth: 3 }"
            :data="beatifyChanges(item.properties)"
          />
        </td>
        <td>{{ item.created_at }}</td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import TreeView from "./jsonViewer/TreeView.vue";

export default {
  name: "",
  props: {
    user_id: {
      default: 0,
    },
    userName: {
      default: "",
    },
  },

  components: {
    "tree-view": TreeView,
  },

  data() {
    return {
      items: [],
      search: "",
      loading: true,
      headers: [
        { text: "شناسه", value: "id", align: "right" },
        { text: "عمل اجرا شده", value: "description", align: "right" },
        { text: " نوع آیتم", value: "log_name", align: "right" },
        { text: "شناسه آیتم", value: "subject_id", align: "right" },
        { text: "تغییرات", value: "changes", align: "right" },
        { text: "زمان", value: "created_at", align: "right" },
      ],
      end_date: null,
      start_date: null,
    };
  },

  methods: {
    reloadActivities() {
      const { user_id, start_date, end_date } = this;
      let params = { user_id, start_date, end_date };

      this.loading = true;
      this.axios.get("activities", { params }).then((response) => {
        this.items = response.data;
        this.loading = false;
      });
    },

    beatifyChanges(properties) {
      if (properties.old) {
        return {
          فعلی: properties.attributes,
          قبلی: properties.old,
        };
      } else {
        return {
          مشخصات: properties.attributes,
        };
      }
    },

    setStartDate(value) {
      this.start_date = value;
    },

    setEndDate(value) {
      this.end_date = value;
    },
    persianFilter(georgian_time) {
      if (georgian_time) {
        return new Date(georgian_time).toLocaleString("fa").replace("،", " - ");
      } else {
        return "";
      }
    },

    printTable(excel) {
      let data = {
        headers: [
          { text: "شناسه", value: "id" },
          { text: "عمل اجرا شده", value: "description" },
          { text: " نوع آیتم", value: "log_name" },
          { text: "شناسه آیتم", value: "subject_id" },
          { text: "زمان", value: "created_at", filter: this.persianFilter },
        ],
        items: this.$refs.tbl.filteredItems,
        title: "تاریخچه کاری " + this.userName,
      };
      if (excel) return this.xl_tables(data, "logs", this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },
  },
  created() {
    if (this.user_id !== 0) {
      let current = new Date();
      this.end_date = current.toLocaleDateString("en-ca");
      current.setMonth(current.getMonth() - 1);
      this.start_date = current.toLocaleDateString("en-ca");
      this.reloadActivities();
    }
  },
};
</script>